function fn_part_dialog() {
    var $body = $("body");
    var $dialog = $("[data-dialog]");

    $(document).on('click', '[data-dialog]', function (e) {
        e.preventDefault();
        var $el = $(this);
        $el.addClass("active");
        $.ajax({
            dataType: 'html',
            url: $el.data('dialog')
        }).done(function (data) {
            $(document).find(".elm_dialog_content *").html("");
            if (!$(document).find(".part_dialog").length) {
                $body.addClass("mod--no-scroll").append('<div class="part_dialog"><button class="elm_dialog_background"></button><div class="elm_dialog_content"></button></div></div>');
            }
            $(document).find(".elm_dialog_content").append(data).hide().fadeIn(300);
            $(document).find(".elm_dialog_background").fadeIn(300);
        });
    });

    $(document).on("click", ".elm_dialog_background, [data-dialog-close]", function (e) {
        e.preventDefault();
        $body.removeClass("mod--no-scroll");
        $dialog.removeClass("active");
        $(document).find(".elm_dialog_background").fadeOut(300);
        $(document).find(".elm_dialog_content").fadeOut(300);

        setTimeout(function () {
            $(document).find(".part_dialog").remove();
        }, 500);
    });
}